import { ViewInfo } from "./view-info.model";

export class ViewState {
    constructor(public loading = false, public inited = false, public viewInfo: ViewInfo = null) {
    }

    setViewInfo(viewInfo: ViewInfo): void {
        this.viewInfo = viewInfo;
        if (this.viewInfo != null) {
            this.loading = false;
        }
    }
}